module.exports = window.DecorationH5Comps;